import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useQuery } from 'react-query';
import { UserKeys } from './user.keys';

export const getSpecialtiesList = async () => {
  const response = await clients.admin.get(`/userprofiles/specialties`);
  return response.data as string[];
};

export const useGetSpecialtiesList = () =>
  useQuery(UserKeys.specialties(), () => getSpecialtiesList());

export const getAccreditationSpecialtiesList = async () => {
  const response = await clients.admin.get(`/userprofiles/accreditationspecialties`);
  return response.data as string[];
};

export const useGetAccreditationSpecialtiesList = () =>
  useQuery(UserKeys.accreditationSpecialties(), () => getAccreditationSpecialtiesList());
